module.exports = __webpack_public_path__ + "static/media/security-brikk-preview.f746326a.png";